// extracted by mini-css-extract-plugin
export default {"appWidth":"800px","ToggleTexts":"GRI_ToggleTexts__vx2N6","ButtonDiv":"GRI_ButtonDiv__E4cVh","DisclosureText":"GRI_DisclosureText__RBtML"};